import { TypeOfEtity } from '../model/enum/typeOfEntity';

// Adresa stranice za stavku iz liste (kategorija, oblast, lekcija...); undefined ako stavka nema svoju stranicu.
export const getEntityPath = (item: any): string | undefined => {
    switch (item?.tip) {
        case TypeOfEtity.Kategorija:
            return `/user/kategorija/${item.id}`;
        case TypeOfEtity.Podkategorija:
            return `/user/podkategorija/${item.id}`;
        case TypeOfEtity.SkupOblasti:
            return `/user/skup-oblasti/${item.id}`;
        case TypeOfEtity.Oblast:
            return `/user/oblast/${item.id}`;
        case TypeOfEtity.Podoblast:
            return `/user/podoblast/${item.id}`;
        case TypeOfEtity.Lekcija:
            return `/user/lekcija/${item.id}`;
    }
    if (item?.naziv === 'Klasik') return '/user/kviz/klasik';
    if (item?.naziv === 'Lovac - Vežbanje') return '/user/kviz/lovac';
    if (item?.naziv === 'Lovac - Takmičarski') return '/user/kviz/lovac/takmicarski';
    return undefined;
};
